import { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { i18nContext } from 'context/i18n';

import styles from './style.module.css';

const BetterProductBlock = ({
  title, text, expanded,
}) => {
  const [ showText, setShowText ] = useState(text.length > 100 && !expanded ? `${text.substring(0, 100).substring(0, text.substring(0, 100).lastIndexOf(' ') + 1)}...` : text);
  const { t } = useContext(i18nContext);

  return (
    <div>
      {title &&
        <div className={styles.itemTitle}>{title}</div>
      }
      {text &&
        <div>
          <div>{showText}</div>
          { showText.length !== text.length &&
            <p className={styles.readMore} onClick={() => setShowText(text)}>{t('generico', 'leer.mas', 'Read more')}</p>
          }
        </div>
      }
    </div>
  );
};

BetterProductBlock.defaultProps = {
  expanded: false,
};

BetterProductBlock.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
};

const BetterProduct = ({
  title, tiers,
}) => {
  const { t } = useContext(i18nContext);
  const pretitleMap = {
    'ico-extraordinary-grip': t('better.product', 'titulo.durabilidad', 'Durability'),
    'ico-materials': t('better.product', 'titulo.materiales', 'Materials'),
    'ico-certifications': t('better.product', 'titulo.certificaciones', 'Certifications'),
  };

  return (
    <div className={styles.betterProductDiv}>
      <h2 className={styles.title}>{title}</h2>
      <div className={tiers.length > 2 ? styles.betterProductListThree : styles.betterProductList}>
        {tiers.map((tier, index) => <div key={`batterProduct-${index}`} className={styles.betterProductItem}>
            <div className={styles.pretitle}>{pretitleMap[tier.iconSvg] && pretitleMap[tier.iconSvg]}</div>
            <div className={styles.icon}>
              <img height={56} width={56} src={`/assets-new/img/product-benefits/svg/${tier.iconSvg}.svg`} />
            </div>
            {tier.blocks.map((block, i) => <div key={`batterProductBlock-${i}`}>
              <BetterProductBlock title={block.title} text={block.text} expanded={tier.blocks.length < 2 && true }/>
            </div>)}
          </div>)}
      </div>
    </div>
  );
};

BetterProduct.propTypes = {
  title: PropTypes.string.isRequired,
  tiers: PropTypes.array.isRequired,
};

export default BetterProduct;
